import {
    BUSINESS_AGREEMENT_STATUS_DISMISSED,
    BUSINESS_AGREEMENT_STATUS_DRAFT,
    BUSINESS_AGREEMENT_STATUS_READY,
    COUPON_CAMPAIGN_STATUS_ACTIVE,
    COUPON_CAMPAIGN_STATUS_DISMISSED,
    COUPON_CAMPAIGN_STATUS_DRAFT,
    COUPON_CODE_STATUS_DELIVERED,
    COUPON_CODE_STATUS_NOT_USED,
    COUPON_CODE_STATUS_USED,
    PRODUCT_STATUS_DISMISSED,
    PRODUCT_STATUS_DRAFT,
    PRODUCT_STATUS_READY,
    PROMO_STATUS_ACTIVE,
    PROMO_STATUS_DISABLED,
    PROMO_STATUS_DRAFT,
    PROMO_TYPOLOGY_CREDIT_CARD, PROMO_TYPOLOGY_SHORT_TERM,
    PROMO_TYPOLOGY_SUBSCRIPTION,
    PROMO_VISIBILITY_PRIVATE,
    PROMO_VISIBILITY_PUBLIC
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useStatusValuesPromo = () => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'promo'});
    const theme = useTheme();
    const getStatusColor = (status: string) => {
        switch (status) {
            case PROMO_STATUS_ACTIVE: return theme.palette.success.transparent;
            case PROMO_STATUS_DISABLED: return theme.palette.error.transparent;
            case PROMO_STATUS_DRAFT: return theme.palette.warning.transparent;
        }
    };

    const getStatusLabel = (status: string) => {
        switch (status) {
            case PROMO_STATUS_ACTIVE: return t('statusValues.active');
            case PROMO_STATUS_DISABLED: return t('statusValues.disabled');
            case PROMO_STATUS_DRAFT: return t('statusValues.draft');
            case PROMO_VISIBILITY_PRIVATE: return t('private');
            case PROMO_VISIBILITY_PUBLIC: return t('public');
            case PROMO_TYPOLOGY_SUBSCRIPTION: return t('typologies.subscription');
            case PROMO_TYPOLOGY_CREDIT_CARD: return t('typologies.creditCard');
            case PROMO_TYPOLOGY_SHORT_TERM: return t('typologies.shortTerm');
        }
    };

    return {
        getStatusColor,
        getStatusLabel
    }
}